import { Invoice } from "../../services/BillingService";
import { CommonFactoryInterface } from "../common-factory-type";
import { UpdateInvoiceStatusDto } from "./factory-dtos";

/**
 * Label change = only the label (QA batch 12, 2026-10-21). This used to copy
 * the whole list row into update-invoice; the row has no invoice number or
 * assignee, so the invoice number became 0 and the assignee was removed.
 */
class UpdateInvoiceStatusFactory
  implements
    CommonFactoryInterface<
      {
        invoice: Partial<Invoice> & { id?: string };
        status: string | null;
      },
      UpdateInvoiceStatusDto
    >
{
  createModelFromDto = (dto: {
    invoice: Partial<Invoice> & { id?: string };
    status: string | null;
  }): UpdateInvoiceStatusDto => ({
    id: dto.invoice?.id || dto.invoice?.invoiceId || "",
    labelId: dto.status || null,
  });
}

export const updateInvoiceStatusFactory = new UpdateInvoiceStatusFactory();
